import { axios } from "../../../shared/lib/axios";
import { useQuery } from "@tanstack/react-query";

const getTrackCourses = async ({ trackId }) => {
  const res = await axios.apiCadernoVirtual(
    "/certification-service/certification/listCoursesByTrack",
    {
      params: {
        trackId,
      },
    }
  );

  return res.object;
};

export const useTrackCourses = ({ config, trackId }) => {
  return useQuery({
    ...config,
    queryKey: ["trackCourses", { trackId }],
    queryFn: () => getTrackCourses({ trackId }),
  });
};
